import AccessRoute from "components/HOC/AccessRoute";
import access from "helpers/access";
import Services from "pages/Services";
import ServiceLists from "pages/Services/ServiceLists";
import { Route, Routes } from "react-router-dom";
import ServiceDetailPage from "pages/Services/ServiceDetails/Links/ServiceDetailPage";

const ServicesPage = () => {
	return (
		<Services>
			<Routes>
				<Route element={<AccessRoute access={access.serviceAccess} />}>
					<Route path={`:id/*`} element={<ServiceDetailPage />} />
					<Route index element={<ServiceLists />} />
				</Route>
			</Routes>
		</Services>
	);
};

export default ServicesPage;
